/** Increments the given string value + 1 */
export function Increment(T) {
    return (parseInt(T) + 1).toString();
}
